import { SyntheticEvent, useState } from "react"
import { Box, Tab, Tabs } from "@mui/material"
import { makeStyles } from "tss-react/mui"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faFileInvoiceDollar } from "@fortawesome/pro-light-svg-icons"
import { PageHeader } from "../../../../../shared/components/pageHeader/PageHeader"
import { LocalizedStrict } from "../../../../localization/components/AppLocalized"
import { Page } from "../../../../../shared/components/pageHeader/PageHeaderApi"
import { MERCHANT_ACCOUNTING_ROUTE } from "../../../../../constants/routes"
import {
    Breadcrumb,
    BreadcrumbLink,
    StandardBreadcrumbs,
} from "../../../../../shared/components/links/StandardBreadcrumbs"
import { OrderAccountingTab } from "../components/OrderAccountingTab"
import { useAppLocalization } from "../../../../localization/components/AppLocalizationProvider"
import { TabPanel } from "../../../../../shared/components/tabs/tabPanel"
import { MeetingServiceAccountingTab } from "../components/MeetingServiceAccountingTab"
import { MatchEnvironment } from "../../../../environment/components/MatchEnvironment"
import { EnvironmentType } from "../../../../environment/envTypes"
import { ComingSoonPlaceholder } from "../../../../../shared/components/placeholders/ComingSoonPlaceholder"
import { useSearchParams } from "react-router-dom"

const useStyles = makeStyles()(() => ({
    content: {
        width: "100%",
    },
    tabsWrap: {
        borderBottom: "1px solid rgba(0, 0, 0, 0.12)",
        marginBottom: "2rem",
    },
    tab: {
        textTransform: "none",
    },
}))

const tabIndex = {
    meetingService: 0,
    transactions: 1,
    refill: 2,
}

export function Orders() {
    const { classes } = useStyles()
    const { l10n } = useAppLocalization()
    const [searchParams] = useSearchParams()
    const tab = searchParams.get("tab")
    const [activeTab, setActiveTab] = useState(Number(tab) ?? tabIndex.transactions)

    const handleTabChange = (event: SyntheticEvent, newActiveTab: number) => {
        setActiveTab(newActiveTab)
    }

    return (
        <>
            <LocalizedStrict id="accounting-orders-page-header" attrs={{ title: true }}>
                <PageHeader
                    page={Page.ACCOUNTING_ORDERS}
                    title="Orders"
                    icon={<FontAwesomeIcon icon={faFileInvoiceDollar} />}
                >
                    <StandardBreadcrumbs>
                        <LocalizedStrict id="merchant-nav-item-home">
                            <BreadcrumbLink to={MERCHANT_ACCOUNTING_ROUTE}>Home</BreadcrumbLink>
                        </LocalizedStrict>

                        <LocalizedStrict id="merchant-nav-item-accounting">
                            <Breadcrumb>Accounting</Breadcrumb>
                        </LocalizedStrict>

                        <LocalizedStrict id="accounting-orders-breadcrumb-title">
                            <Breadcrumb>Orders</Breadcrumb>
                        </LocalizedStrict>
                    </StandardBreadcrumbs>
                </PageHeader>
            </LocalizedStrict>

            <Box className={classes.content}>
                <Box className={classes.tabsWrap}>
                    <Tabs value={activeTab} onChange={handleTabChange}>
                        <Tab
                            value={tabIndex.meetingService}
                            label={l10n.getString("accounting-orders-tab-meetingService")}
                            wrapped
                            className={classes.tab}
                        />
                        <Tab
                            value={tabIndex.transactions}
                            label={l10n.getString("accounting-orders-tab-transactions")}
                            wrapped
                            className={classes.tab}
                        />
                        <Tab
                            value={tabIndex.refill}
                            label={l10n.getString("accounting-orders-tab-refill")}
                            wrapped
                            className={classes.tab}
                        />
                    </Tabs>
                </Box>
                <TabPanel value={activeTab} index={tabIndex.meetingService}>
                    <MatchEnvironment
                        environments={[EnvironmentType.Local, EnvironmentType.Test, EnvironmentType.Demo]}
                    >
                        <MeetingServiceAccountingTab />
                    </MatchEnvironment>
                    <MatchEnvironment environments={[EnvironmentType.QA, EnvironmentType.Prod]}>
                        <LocalizedStrict id="planning-tabs-placeholder" attrs={{ title: true, body: true }}>
                            <ComingSoonPlaceholder
                                title="Coming soon"
                                body="We are working to bring you this feature."
                            />
                        </LocalizedStrict>
                    </MatchEnvironment>
                </TabPanel>
                <TabPanel value={activeTab} index={tabIndex.transactions}>
                    <OrderAccountingTab tabQueryParam="TRANSACTIONS" />
                </TabPanel>
                <TabPanel value={activeTab} index={tabIndex.refill}>
                    <OrderAccountingTab tabQueryParam="REFILL" />
                </TabPanel>
            </Box>
        </>
    )
}
